import { useState, useEffect, SetStateAction } from 'react';
import { isPCAdapterActive } from 'lib/utils/pcAdapter';

const useOrientation = () => {
  const [isLandscape, toggleIsLandscape] = useState(false);

  useEffect(() => {
    // PCAdapter 启用后，横屏逻辑不再用于驱动 PC 页面资源/布局分支。
    // PC 页面由运营独立配置，固定返回 false，避免命中移动端的横屏分支。
    if (isPCAdapterActive()) return;

    const mediaQuery = window.matchMedia('(orientation: landscape)');
    toggleIsLandscape(mediaQuery.matches);

    const onOrientationChange = (m: { matches: SetStateAction<boolean>; }) => {
      toggleIsLandscape(m.matches);
    };

    mediaQuery.addListener(onOrientationChange);
    return () => {
      mediaQuery.removeListener(onOrientationChange);
    };
  }, []);

  return {
    isLandscape,
  };
};

export default useOrientation;
